






























































































import Vue, { PropType } from 'vue'
import { Account } from 'types/src'
import {
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
  BDropdownText,
} from 'bootstrap-vue'
export default Vue.extend({
  name: 'CpHeader',
  components: {
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BDropdownText,
  },
  props: {
    account: {
      type: Object as PropType<Account>,
    },
  },
  data() {
    return {
      menu: false,
      menuMouseOver: false,
    }
  },
  computed: {
    isMenuSelect(): boolean {
      return this.menu || this.menuMouseOver
    },
  },
  mounted() {
    document.body.addEventListener('click', (e) => {
      if (e.target == this.$refs['menu-button']) {
        this.menu = !this.menu
        return
      }

      if (e.target != this.$refs['menu']) {
        this.menu = false
      }
    })
  },
  methods: {
    onMouseEnter() {
      this.menuMouseOver = true
    },
    onMouseLeave() {
      this.menuMouseOver = false
    },
    selectDevice() {
      this.$emit('device')
    },
    selectMyAccount() {
      this.$emit('my-account')
    },
    selectMyAccountInfo() {
      this.$emit('my-account-info')
    },
    selectMailUpdate() {
      this.$emit('mail-update')
    },
    selectEdit() {
      this.$emit('edit')
    },
    selectPasswordUpdate() {
      this.$emit('password-update')
    },
    selectLogout() {
      this.$emit('logout')
    },
    showMenu() {
      console.log('showMenu')
      this.menu = true
    },
  },
})
